function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0.16,
  y1: 0.16,
  x2: 0.849,
  y2: 0.849,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e6e6e6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 0.852,
  y1: 0.852,
  x2: 0.091,
  y2: 0.091,
  xlinkHref: "#a"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1430.642,2593.107a135.7,135.7,0,1,1-135.7-135.694A135.694,135.694,0,0,1,1430.642,2593.107Z",
  opacity: 0
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1430.642,2592.008a135.7,135.7,0,1,1-135.7-135.7A135.693,135.693,0,0,1,1430.642,2592.008Z",
  opacity: 0.083
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M1430.642,2590.906a135.7,135.7,0,1,1-135.7-135.694A135.694,135.694,0,0,1,1430.642,2590.906Z",
  opacity: 0.167
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M1430.642,2589.8a135.7,135.7,0,1,1-135.7-135.695A135.695,135.695,0,0,1,1430.642,2589.8Z",
  opacity: 0.25
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M1430.642,2588.705a135.7,135.7,0,1,1-135.7-135.7A135.694,135.694,0,0,1,1430.642,2588.705Z",
  opacity: 0.333
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M1430.642,2587.6a135.7,135.7,0,1,1-135.7-135.7A135.694,135.694,0,0,1,1430.642,2587.6Z",
  opacity: 0.417
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M1430.642,2586.5a135.7,135.7,0,1,1-135.7-135.695A135.694,135.694,0,0,1,1430.642,2586.5Z",
  opacity: 0.5
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M1430.642,2586.5a135.7,135.7,0,1,1-135.7-135.695A135.695,135.695,0,0,1,1430.642,2586.5Z",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 121.286,
  cy: 121.286,
  r: 121.286,
  transform: "translate(1173.66 2465.218)",
  fill: "#2d250c"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 108.936,
  cy: 108.936,
  r: 108.936,
  transform: "translate(1173.819 2681.699) rotate(-83.164)",
  fill: "url(#a)"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 103.726,
  cy: 103.726,
  r: 103.726,
  transform: "translate(1182.889 2491.841) rotate(-4.81)",
  fill: "url(#b)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M1294.942,2540.084a3.3,3.3,0,1,1,3.3-3.295A3.3,3.3,0,0,1,1294.942,2540.084Zm0-4.607a1.31,1.31,0,1,0,1.31,1.312A1.312,1.312,0,0,0,1294.942,2535.477Z",
  fill: "#2d250c"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M1298.675,2548.215h-7.457a1,1,0,0,1-1-1v-2.571a3.573,3.573,0,0,1,3.571-3.566h2.305a3.572,3.572,0,0,1,3.569,3.566v2.571A.993.993,0,0,1,1298.675,2548.215Zm-6.461-1.987h5.465v-1.58a1.583,1.583,0,0,0-1.581-1.582h-2.305a1.582,1.582,0,0,0-1.579,1.582Z",
  fill: "#2d250c"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M1294.942,2585.12a5.634,5.634,0,1,1,5.645-5.632A5.643,5.643,0,0,1,1294.942,2585.12Zm0-9.284a3.647,3.647,0,1,0,3.657,3.652A3.659,3.659,0,0,0,1294.942,2575.836Z",
  fill: "#2d250c"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M1302.467,2598.879h-15.044a.994.994,0,0,1-.994-1v-5.194a6.2,6.2,0,0,1,6.191-6.186h4.649a6.2,6.2,0,0,1,6.191,6.186v5.194A.993.993,0,0,1,1302.467,2598.879Zm-14.052-1.987h13.058v-4.2a4.209,4.209,0,0,0-4.2-4.2h-4.649a4.211,4.211,0,0,0-4.2,4.2Z",
  fill: "#2d250c"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M1294.942,2610.855a.977.977,0,0,1-.495-.134l-20.458-11.8a1,1,0,0,1-.5-.859v-23.612a1,1,0,0,1,.5-.862l10.233-5.906,10.225-5.9a1,1,0,0,1,.993,0l10.23,5.9,10.228,5.907a1,1,0,0,1,.5.862v23.612a1,1,0,0,1-.5.859l-20.457,11.8A.969.969,0,0,1,1294.942,2610.855Zm-19.462-13.367,19.462,11.228,19.465-11.228v-22.461l-9.733-5.622-9.732-5.614-19.462,11.236Z",
  fill: "#2d250c"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M1294.942,2563.639a.994.994,0,0,1-.991-.994v-10.363a.994.994,0,0,1,1.989,0v10.363A1,1,0,0,1,1294.942,2563.639Z",
  fill: "#2d250c"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M1315.619,2575.566a.992.992,0,0,1-.5-1.854l8.975-5.175a1,1,0,0,1,1,1.724l-8.978,5.174A1,1,0,0,1,1315.619,2575.566Z",
  fill: "#2d250c"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M1324.595,2604.6a.992.992,0,0,1-.5-.133l-8.975-5.173a1,1,0,0,1,.993-1.726l8.978,5.177a1,1,0,0,1-.5,1.855Z",
  fill: "#2d250c"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M1294.942,2621.706a.992.992,0,0,1-.991-.991v-10.354a.994.994,0,0,1,1.989,0v10.354A.994.994,0,0,1,1294.942,2621.706Z",
  fill: "#2d250c"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M1265.292,2604.6a.993.993,0,0,1-.5-1.855l8.977-5.177a1,1,0,0,1,.992,1.726l-8.978,5.173A.984.984,0,0,1,1265.292,2604.6Z",
  fill: "#2d250c"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M1274.267,2575.566a.977.977,0,0,1-.494-.131l-8.979-5.184a.993.993,0,1,1,.993-1.72l8.978,5.181a1,1,0,0,1,.362,1.36A.986.986,0,0,1,1274.267,2575.566Z",
  fill: "#2d250c"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M1294.942,2553.277a12.426,12.426,0,1,1,12.437-12.421A12.444,12.444,0,0,1,1294.942,2553.277Zm0-22.866a10.44,10.44,0,1,0,10.452,10.445A10.464,10.464,0,0,0,1294.942,2530.411Z",
  fill: "#2d250c"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M1334.517,2576.1a12.489,12.489,0,0,1-10.783-6.208,12.436,12.436,0,0,1,10.758-18.654,12.493,12.493,0,0,1,10.787,6.222,12.435,12.435,0,0,1-10.762,18.64Zm-.025-22.875a10.447,10.447,0,1,0,9.066,5.229A10.451,10.451,0,0,0,1334.492,2553.23Z",
  fill: "#2d250c"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M1334.5,2621.755a12.423,12.423,0,1,1,10.78-6.213A12.44,12.44,0,0,1,1334.5,2621.755Zm.02-22.87a10.5,10.5,0,0,0-9.065,5.222,10.442,10.442,0,1,0,9.065-5.222Z",
  fill: "#2d250c"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M1294.942,2644.581a12.431,12.431,0,1,1,12.437-12.43A12.449,12.449,0,0,1,1294.942,2644.581Zm0-22.875a10.444,10.444,0,1,0,10.452,10.445A10.464,10.464,0,0,0,1294.942,2621.706Z",
  fill: "#2d250c"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M1255.387,2621.755a12.47,12.47,0,0,1-10.774-6.213,12.434,12.434,0,0,1,10.759-18.644,12.479,12.479,0,0,1,10.78,6.213,12.436,12.436,0,0,1-10.765,18.644Zm-.015-22.87a10.443,10.443,0,1,0,9.057,5.218A10.416,10.416,0,0,0,1255.372,2598.885Z",
  fill: "#2d250c"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M1255.37,2576.1a12.428,12.428,0,1,1,10.782-6.211A12.442,12.442,0,0,1,1255.37,2576.1Zm.024-22.871a10.491,10.491,0,0,0-9.061,5.225,10.441,10.441,0,0,0,3.82,14.261,10.446,10.446,0,1,0,5.241-19.486Z",
  fill: "#2d250c"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M1334.508,2562.9a3.293,3.293,0,1,1,3.294-3.3A3.3,3.3,0,0,1,1334.508,2562.9Zm0-4.6a1.306,1.306,0,1,0,1.307,1.3A1.311,1.311,0,0,0,1334.508,2558.3Z",
  fill: "#2d250c"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M1338.231,2571.043h-7.454a1,1,0,0,1-.995-.992v-2.584a3.571,3.571,0,0,1,3.573-3.56h2.3a3.569,3.569,0,0,1,3.57,3.56v2.584A.993.993,0,0,1,1338.231,2571.043Zm-6.458-1.987h5.464v-1.589a1.578,1.578,0,0,0-1.583-1.57h-2.3a1.577,1.577,0,0,0-1.582,1.57Z",
  fill: "#2d250c"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M1255.383,2608.559a3.3,3.3,0,1,1,3.294-3.3A3.3,3.3,0,0,1,1255.383,2608.559Zm0-4.607a1.311,1.311,0,1,0,1.31,1.311A1.309,1.309,0,0,0,1255.383,2603.952Z",
  fill: "#2d250c"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M1259.109,2616.69h-7.454a.993.993,0,0,1-.994-.995v-2.573a3.574,3.574,0,0,1,3.57-3.567h2.3a3.574,3.574,0,0,1,3.57,3.567v2.573A.993.993,0,0,1,1259.109,2616.69Zm-6.458-1.988h5.462v-1.58a1.58,1.58,0,0,0-1.581-1.58h-2.3a1.578,1.578,0,0,0-1.58,1.58Z",
  fill: "#2d250c"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M1334.508,2608.559a3.3,3.3,0,1,1,3.294-3.3A3.3,3.3,0,0,1,1334.508,2608.559Zm0-4.607a1.311,1.311,0,1,0,1.307,1.311A1.313,1.313,0,0,0,1334.508,2603.952Z",
  fill: "#2d250c"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M1338.236,2616.69h-7.459a1,1,0,0,1-.995-.995v-2.573a3.575,3.575,0,0,1,3.573-3.567h2.3a3.572,3.572,0,0,1,3.571,3.567v2.573A.994.994,0,0,1,1338.236,2616.69Zm-6.463-1.988h5.468v-1.58a1.582,1.582,0,0,0-1.584-1.58h-2.3a1.58,1.58,0,0,0-1.582,1.58Z",
  fill: "#2d250c"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M1294.942,2631.381a3.3,3.3,0,1,1,3.3-3.293A3.3,3.3,0,0,1,1294.942,2631.381Zm0-4.6a1.305,1.305,0,1,0,1.31,1.309A1.312,1.312,0,0,0,1294.942,2626.779Z",
  fill: "#2d250c"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M1298.668,2639.519h-7.45a1,1,0,0,1-1-1v-2.584a3.568,3.568,0,0,1,3.571-3.556h2.3a3.566,3.566,0,0,1,3.567,3.556v2.584A1,1,0,0,1,1298.668,2639.519Zm-6.454-1.99h5.461v-1.589a1.575,1.575,0,0,0-1.58-1.57h-2.3a1.573,1.573,0,0,0-1.579,1.57Z",
  fill: "#2d250c"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M1255.38,2562.9a3.293,3.293,0,1,1,3.294-3.3A3.3,3.3,0,0,1,1255.38,2562.9Zm0-4.6a1.306,1.306,0,1,0,1.306,1.3A1.3,1.3,0,0,0,1255.38,2558.3Z",
  fill: "#2d250c"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M1259.109,2571.043h-7.454a.994.994,0,0,1-.994-.992v-2.584a3.571,3.571,0,0,1,3.57-3.56h2.3a3.57,3.57,0,0,1,3.57,3.56v2.584A.994.994,0,0,1,1259.109,2571.043Zm-6.458-1.987h5.462v-1.589a1.576,1.576,0,0,0-1.581-1.57h-2.3a1.574,1.574,0,0,0-1.58,1.57Z",
  fill: "#2d250c"
});

var SvgPartner7 = function SvgPartner7(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271.395,
    height: 277.994,
    viewBox: "0 0 271.395 277.994",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1159.247 -2450.809)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9), _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPartner7, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/partner7.9a88996b.svg";
export { ForwardRef as ReactComponent };